import React from 'react'
import useImport from '../../import'
import InfoNote from '../../InfoNote'

const resultMap = {
  entities: 'giftcertificates in store',
  updated: 'giftcertificates updated',
  created: 'giftcertificates created',
  deleted: 'giftcertificates deleted',
}

const GiftCertificatesImport = () => {
  const { FileSelector, FileImport, result, fileSelected, disabled } =
    useImport({
      event: 'Gift Certificates import',
      method: 'giftcertificates/import',
      resultMap,
    })

  return (
    <>
      {!result?.runId && !fileSelected && (
        <>
          <FileSelector disabled={disabled} />

          <div className="rounded-md opacity-70 mt-auto pt-4">
            <InfoNote title="Read-only">
              id and order_id are read-only. currency_code can not be updated.
            </InfoNote>
            <InfoNote title="UTC">
              Purchase and expiry times are expected to be in UTC timezone.
            </InfoNote>
            <InfoNote title="Delete">
              Enter "TRUE" in the 1st column to delete a gift certificate.
            </InfoNote>
            <InfoNote title="Have a backup?">
              Make sure you have a{' '}
              <span className="font-bold">recent, unmodified CSV file</span> in
              case you need to restore your data.{' '}
            </InfoNote>
          </div>
        </>
      )}

      {(result?.runId || fileSelected) && <FileImport />}
    </>
  )
}

export default GiftCertificatesImport
